import {
  Paper,
  Group,
  Title,
  Select,
  Button,
  SelectProps,
} from '@mantine/core';
import { IconFileDownload, IconPlus, IconTrash } from '@tabler/icons-react';
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { intercultureQueries } from '../../data-access/queries/interculture';

import { useQueriesWithGlobal } from '@data-access';
import { ActionsMenu, ActionsMenuItem } from '@ui';

interface IntercultureListHeaderProps {
  selectedType: string;
  onCropChange: SelectProps['onChange'];
  selecting: boolean;
  downloadPending?: boolean;
  onEditAdvice: () => void;
  onDownload: () => void;
}

export function IntercultureListHeader({
  selectedType,
  onCropChange,
  onEditAdvice,
  selecting,
  onDownload,
  downloadPending,
}: IntercultureListHeaderProps) {
  const { t } = useTranslation();

  const queries = useQueriesWithGlobal(intercultureQueries);
  const { data } = useSuspenseQuery(queries.types());

  const options = data.map((type) => ({
    value: type.name,
    label: t(`common.crops.${type.name}`),
  }));

  const items: ActionsMenuItem[] = [
    {
      type: 'action',
      label: 'Télécharger le récapitulatif',
      icon: IconFileDownload,
      onClick: () => onDownload(),
      props: {
        disabled: !selecting,
      },
    },
  ];

  return (
    <Paper>
      <Group justify="space-between">
        <Group>
          <Title order={2}>{t('app.nav.interculture')}</Title>
          <Select
            allowDeselect={false}
            data={options}
            onChange={onCropChange}
            value={selectedType}
          />
          <Button color="yellow" disabled={!selecting} onClick={() => onEditAdvice()} >
            Saisir mes données
          </Button>
        </Group>
        <Group>
          <ActionsMenu items={items}>
            <ActionsMenu.Button loading={downloadPending} />
          </ActionsMenu>
        </Group>
      </Group>
    </Paper>
  );
}

export default IntercultureListHeader;
